export function getFilteredTasks(tasks, filters, userid) {
  let filteredValues = [];
  let filteredKeys = [];
  let filteredTasks = tasks;
  // If not for a userid, then return all tasks
  // console.log(filters, userid, tasks);
  if (!filters) {
    return filteredTasks;
  }
  if (!userid) {
    return filteredTasks;
  } else {
    // Filter based on task status
    // console.log("filter status", filters, userid, filteredTasks);
    if (filters.taskStatus === "all") {
    } else {
      const nanoIndexes = filteredTasks.value
        .map((task, i) =>
          task.taskStatus.toUpperCase() === filters.taskStatus.toUpperCase()
            ? i
            : -1
        )
        .filter((index) => index !== -1);

      filteredValues = nanoIndexes.map((item) => filteredTasks.value[item]);

      filteredKeys = nanoIndexes.map((item) => filteredTasks.key[item]);
      filteredTasks = {
        key: filteredKeys,
        value: filteredValues,
      };
    }
    //Filtered based on text
    // console.log(filters.taskName, "task name");
    if (filters.taskName !== "") {
      // console.log("filtering name", filteredTasks);
      const nanoIndexes = filteredTasks.value
        .map((task, i) =>
          task.taskName.toUpperCase().includes(filters.taskName.toUpperCase())
            ? i
            : -1
        )
        .filter((index) => index !== -1);

      filteredValues = nanoIndexes.map((item) => filteredTasks.value[item]);

      filteredKeys = nanoIndexes.map((item) => tasks.key[item]);
      filteredTasks = {
        key: filteredKeys,
        value: filteredValues,
      };
      // console.log("filtered name", filteredTasks);
    }
    return filteredTasks;
  }
  return filteredTasks;
}
